import React from 'react';
import Component from './Auditor';

export default function Admin() {

    return <Component />;
}